export default __webpack_public_path__ + "static/media/order-summary-icon.8d6075c0.svg";